import PropTypes from "prop-types";
import { MenuItem, TextField, Typography, InputAdornment, IconButton } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import ClearIcon from '@material-ui/icons/Clear';
import useCrud from "../../../hooks/useCrud";
import { LoadingButton } from "../../Loading";
import { useFinancialContext } from "../../../context/Financial/FinancialContext";

const SelectBancos = ({ onChange, banco, isDelete: isDisabled, width, handleClear }) => {
  const defaultValues = { varId: 1, value: '' };

  const {
    isLoading,
  } = useCrud('/banks', defaultValues, 'SelectBancos');

  const { bancos, } = useFinancialContext();
  
  const autoCompleteChange = (e, newValue) => {
    const customEvent = {
      target: {
        name: "bankCode",
        value: newValue?.varId
      }
    }
    onChange(customEvent)
  }

  return (
    <>
      {
        isLoading ? (
          <Typography variant="subtitle1">
            Carregando bancos...
            <LoadingButton />
          </Typography>
        ) : (
          <>
            <Autocomplete
              id="bankCode"
              options={bancos}
              getOptionLabel={(option) => `${option.varId.toString().padStart(3, '0')} - ${option.value}`}
              value={bancos.find(option => option?.varId === banco)}
              renderInput={(params) => <TextField {...params} label="Banco" variant="outlined" InputLabelProps={{ shrink: true }} />}
              fullWidth
              disabled={isDisabled}
              onChange={autoCompleteChange}
            />            
          </>
        )
      }
    </>
  );
};


SelectBancos.propTypes = {
  onChange: PropTypes.func.isRequired,
  banco: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number,
  ]),
  isDelete: PropTypes.bool.isRequired,
  handleClear: PropTypes.func.isRequired,
  width: PropTypes.bool,
}

SelectBancos.defaultProps = {
  banco: [],
  width: true,
}

export default SelectBancos;